import { render, staticRenderFns } from "./ProductRecommendation.vue?vue&type=template&id=106e0ebc&scoped=true&"
import script from "./ProductRecommendation.vue?vue&type=script&lang=js&"
export * from "./ProductRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./ProductRecommendation.vue?vue&type=style&index=0&id=106e0ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106e0ebc",
  null
  
)

/* custom blocks */
import block0 from "./ProductRecommendation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VIcon,VList,VTooltip})
